module.exports = __webpack_public_path__ + "img/green-power.cb7b8403.svg";